import { createFileRoute } from "@tanstack/react-router"

import { membersSettingsSearchSchema } from "@/features/members/members-search-schema"
import { Perm } from "@/lib/permissions"
import { requirePermission } from "@/lib/route-guards"
import { SettingsUsersPermissionsPage } from "@/pages/settings/users-permissions"

export const Route = createFileRoute("/_authenticated/settings/users")({
  validateSearch: (search) => membersSettingsSearchSchema.parse(search),
  beforeLoad: async ({ context }) => {
    await requirePermission(context, Perm.MEMBERSHIP_READ, { to: "/settings/general" })
  },
  component: SettingsUsersPermissionsPage,
})
